import { useHasPermission } from "../auth/useClaims";

// One permission covers view and manage together - there is deliberately no
// Amc.ViewEquipment, per direct instruction and
// feedback_no_separate_view_permission_for_masters. Batch135 also widened the
// product, customer and quotation-prototype read endpoints to accept this code, so
// a holder needs no separate Products.View / Customers.View / Quotation.Create
// grant to use the pickers on these screens.
export const useCanManageAmcEquipment = () => useHasPermission("Amc.ManageEquipment");

// Separate from equipment: a contract is a commercial agreement while equipment is a
// register, so a branch may well let someone maintain one but not the other.
export const useCanManageAmcContracts = () => useHasPermission("Amc.ManageContracts");
